/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalFolder,
    ExternalFolderFromJSON,
    ExternalFolderFromJSONTyped,
    ExternalFolderToJSON,
    ExternalPartners,
    ExternalPartnersFromJSON,
    ExternalPartnersFromJSONTyped,
    ExternalPartnersToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalFolderExternalPartnerResponse
 */
export interface ExternalFolderExternalPartnerResponse {
    /**
     * 
     * @type {ExternalPartners}
     * @memberof ExternalFolderExternalPartnerResponse
     */
    partner?: ExternalPartners;
    /**
     * 
     * @type {number}
     * @memberof ExternalFolderExternalPartnerResponse
     */
    responseCode?: number;
    /**
     * 
     * @type {ExternalFolder}
     * @memberof ExternalFolderExternalPartnerResponse
     */
    data?: ExternalFolder;
}

export function ExternalFolderExternalPartnerResponseFromJSON(json: any): ExternalFolderExternalPartnerResponse {
    return ExternalFolderExternalPartnerResponseFromJSONTyped(json, false);
}

export function ExternalFolderExternalPartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalFolderExternalPartnerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partner': !exists(json, 'partner') ? undefined : ExternalPartnersFromJSON(json['partner']),
        'responseCode': !exists(json, 'responseCode') ? undefined : json['responseCode'],
        'data': !exists(json, 'data') ? undefined : ExternalFolderFromJSON(json['data']),
    };
}

export function ExternalFolderExternalPartnerResponseToJSON(value?: ExternalFolderExternalPartnerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partner': ExternalPartnersToJSON(value.partner),
        'responseCode': value.responseCode,
        'data': ExternalFolderToJSON(value.data),
    };
}


